import { useState } from 'react';
import { useOnlineStatus } from '../offline/ConnectivityContext';
import { useAuth } from './AuthContext';

// Formulaire de connexion partagé par la page /login, l'écran de la garde et la modale
// de reconnexion. Dans la modale (`forgotInNewTab`), « Mot de passe oublié ? » s'ouvre dans un
// nouvel onglet pour ne pas quitter la page en cours.
export default function LoginForm({ defaultEmail = '', onSuccess, autoFocusPassword = false, forgotInNewTab = false }) {
    const { login } = useAuth();
    const { isOnline } = useOnlineStatus();
    const [email, setEmail] = useState(defaultEmail);
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);
        setSubmitting(true);
        try {
            const user = await login(email, password);
            onSuccess?.(user);
        } catch (err) {
            setError(err.message);
            setPassword('');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <form className="auth-form" onSubmit={handleSubmit}>
            <div className="auth-field">
                <label htmlFor="auth-email">Email</label>
                <input
                    id="auth-email" type="email" autoComplete="username" required
                    value={email} onChange={(e) => setEmail(e.target.value)}
                    autoFocus={!autoFocusPassword}
                />
            </div>
            <div className="auth-field">
                <label htmlFor="auth-password">Mot de passe</label>
                <input
                    id="auth-password" type="password" autoComplete="current-password" required
                    value={password} onChange={(e) => setPassword(e.target.value)}
                    autoFocus={autoFocusPassword}
                />
            </div>
            {error && <div className="auth-error" role="alert">{error}</div>}
            {!isOnline && <div className="auth-hint">Hors connexion : la connexion nécessite le réseau.</div>}
            <button type="submit" className="auth-btn auth-btn--primary" disabled={submitting || !isOnline}>
                {submitting ? 'Connexion…' : 'Se connecter'}
            </button>
            <a
                className="auth-link auth-forgot-link" href="/mot-de-passe-oublie"
                target={forgotInNewTab ? '_blank' : undefined} rel={forgotInNewTab ? 'noopener' : undefined}
            >
                Mot de passe oublié ?
            </a>
        </form>
    );
}
